/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';

const EllipsisText = ({ limit, data, multiline = false, symbol = '...', mode = 'tail' }) => {
  const [text, setText] = useState(data);
  useEffect(() => {
    if (multiline) {
      // we have to add multiline logic
    } else {
      // char length logic with default tail
      setText(data.length > limit ? data.substring(0, limit) + symbol : data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <span>{text}</span>;
};

export default EllipsisText;
